export default __webpack_public_path__ + "static/media/grafema_martini-contest_10.010172e9.mp4";